<template>
  <div>
    <v-form ref="form">
      <div class="d-flex justify-end mt-2 mb-2">
        <span class="text-caption text-right red--text">
          *Se a categoria selecionada for equipamento, os campos Unidade,
          Setor e Sub-setor serão herdados do equipamento.
        </span>
      </div>

      <v-row class="ma-0">
        <v-col cols="12" class="py-0">
          <strong>Selecione os campos comuns</strong>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes(FIELD_KEYS.UNIDADE)"
        >
          <label class="ml-1 text-caption"> {{ $t('Unidade') }} </label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            v-model="data.unidadeId"
            :rules="[(v) => !!v || 'Selecione a unidade']"
            @change="category == 1 ? getDepartments(data.unidadeId) : null"
            :items="unidades"
            item-text="name"
            item-value="id"
            :readonly="category == 0"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Unidade')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="6" md="4" v-if="selectedFields.includes(FIELD_KEYS.SETOR)">
          <label class="ml-1 text-caption"> {{ $t('Setor') }} </label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            :disabled="category == 1 && !data.unidadeId"
            v-model="data.departmentId"
            :rules="[(v) => !!v || 'Selecione o setor']"
            @change="category == 1 ? getSubDepartments(data.departmentId) : null"
            :items="departments"
            item-text="name"
            item-value="id"
            :readonly="category == 0"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Setor')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes(FIELD_KEYS.SUB_SETOR)"
        >
          <label class="ml-1 text-caption"> {{ $t('Sub-setor') }} </label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            :disabled="category == 1 && !data.departmentId"
            v-model="data.subDepartmentId"
            :items="subDepartments"
            item-text="name"
            item-value="id"
            :readonly="category == 0"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="data.subDepartmentId == null ? 'N/A' : $t('Sub-setor')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes(FIELD_KEYS.LOCALIZACAO) && category == 1"
        >
          <label class="ml-1 text-caption"> {{ $t('Localização') }} </label>
          <v-text-field
            v-model="data.location"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Localização')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes(FIELD_KEYS.IDENTIFICACAO) && category == 0"
        >
          <label class="ml-1 text-caption"> {{ $t('Identificação') }} </label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            v-model="data.equipmentId"
            @change="syncDepartmentAndSubDepartmentByEquipment"
            :rules="[(v) => !!v || 'Selecione o equipamento']"
            item-text="identification"
            :items="equipments"
            item-value="id"
            outlined
            style="min-width: 200px"
            class="ma-1 primary-input"
            hide-details="auto"
            placeholder="Identificação"
            value="Identificação"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
            <template v-slot:item="{ item }">
              <span class="text-caption">
                {{ item.identification }} / {{ item.name }}
              </span>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes(FIELD_KEYS.NOME_OS)"
        >
          <label class="ml-1 text-caption"> {{ $t('Nome O.S.') }} </label>
          <v-text-field
            v-model="data.name"
            :rules="[(v) => !!v || 'Digite o nome para a O.S.']"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Nome O.S.')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes(FIELD_KEYS.TIPO_OS)"
        >
          <label class="ml-1 text-caption"> Tipo O.S. </label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            v-model="data.serviceOrderType"
            :item-text="(item) => $t(item.text)"
            item-value="value"
            :rules="[(v) => v != null || 'Selecione o Tipo da O.S.']"
            outlined
            class="primary-input"
            :items="types"
            hide-details="auto"
            :placeholder="$t('Tipo O.S.')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes(FIELD_KEYS.RESPONSAVEL)"
        >
          <label class="ml-1 text-caption"> {{ $t('Responsável') }} </label>
          <v-autocomplete
            append-icon="mdi-chevron-down"
            v-model="data.responsibleName"
            :rules="[(v) => !!v || 'Selecione o responsável']"
            item-text="name"
            item-value="name"
            :items="users"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Responsável')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes(FIELD_KEYS.SOLICITANTE)"
        >
          <label class="ml-1 text-caption"> {{ $t('Solicitante') }} </label>
          <v-text-field
            v-model="data.requester"
            :rules="[(v) => !!v || 'Digite o Solicitante']"
            outlined
            class="primary-input"
            hide-details="auto"
            placeholder="Solicitante"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes(FIELD_KEYS.DATA_HORA_SOLICITACAO)"
        >
          <label class="ml-1 text-caption">
            {{ $t('Data de solicitação') }}
          </label>

          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <input
                :class="requestDateTimeError ? 'date-input-error' : 'date-input'"
                :value="formatDateTime(data.dateTimeRequest)"
                placeholder="DD/MM/AAAA HH:MM"
                readonly
                v-bind="attrs"
                v-on="on"
              />
              <span class="date-span-error" v-if="requestDateTimeError">
                {{ $t('Selecione a data de solicitação') }}
              </span>
            </template>
            <date-picker
              v-model="data.dateTimeRequest"
              mode="dateTime"
              is24hr
              is-inline
            />
          </v-menu>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="selectedFields.includes(FIELD_KEYS.SOLICITACAO_RECLAMACAO)"
        >
          <label class="ml-1 text-caption">
            {{ $t('Solicitação / Reclamação') }}
          </label>
          <v-text-field
            v-model="data.request"
            :rules="[(v) => !!v || 'Digite a Solicitação / Reclamação']"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Solicitação / Reclamação')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="
            selectedFields.includes(FIELD_KEYS.OFICINA) &&
            institution.departmentTypes.includes(1)
          "
        >
          <label class="ml-1 text-caption"> {{ $t('Oficina') }} </label>
          <v-autocomplete
            v-model="data.workshopId"
            :items="workshopTypes"
            item-text="name"
            item-value="id"
            autocomplete="off"
            :rules="[(v) => v != null || 'Oficina obrigatório']"
            outlined
            class="primary-input"
            hide-details="auto"
            :placeholder="$t('Oficina')"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>

    </v-form>

    <div class="d-flex justify-end">
      <v-btn text @click="$emit('back')"> {{ $t('Voltar') }} </v-btn>
      <v-btn color="primary mr-0" elevation="0" @click="confirm">
        {{ $t('Continue') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ApiService from '../../../../../../services/ApiService'
import { FIELD_KEYS } from './fieldKeys'

export default {
  name: 'CommomFieldsStep',

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.getWorkshops()
  },

  props: {
    selectedFields: Array,
    category: Number,
    users: Array,
    equipments: Array,
    types: Array,
    unidades: Array,
  },

  data: () => ({
    FIELD_KEYS,
    institution: {},
    data: {
      unidadeId: null,
      departmentId: null,
      subDepartmentId: null,
      location: '',
      equipmentId: null,
      name: '',
      requester: '',
      serviceOrderType: null,
      responsibleName: '',
      dateTimeRequest: null,
      request: '',
      workshopId: null,
    },
    dateMenu: false,
    requestDateTimeError: false,
    workshopTypes: [
      { text: 'Carpintaria', value: 0 },
      { text: 'Elétrica', value: 2 },
      { text: 'Hidráulica', value: 3 },
      { text: 'Climatização', value: 4 },
      { text: 'Gasoterapia', value: 5 },
      { text: 'Zeladoria', value: 6 },
      { text: 'Vidraçaria', value: 7 },
      { text: 'Mecânica', value: 8 },
      { text: 'Serralheria', value: 9 },
      { text: 'Predial Civil', value: 10 },
      { text: 'Pintura Predial', value: 11 },
      { text: 'Pintura Industrial', value: 12 },
    ],
    apiService: new ApiService(),
    departments: [],
    subDepartments: [],
  }),

  methods: {
    async syncDepartmentAndSubDepartmentByEquipment() {
      if (this.category != 0) return

      const equipment = this.equipments.find((x) => x.id == this.data.equipmentId)

      if (!equipment) {
        this.data.unidadeId = null
        this.data.departmentId = null
        this.data.subDepartmentId = null
        this.departments = []
        this.subDepartments = []
        return
      }

      this.data.unidadeId = equipment.unidadeId
      this.data.departmentId = equipment.departmentId

      if (this.data.unidadeId) {
        await this.getDepartments(this.data.unidadeId)
      }

      this.getSubDepartments(this.data.departmentId, false)
      this.data.subDepartmentId = equipment.subDepartmentId
    },

    getWorkshops() {
      this.apiService
        .get('workshop/' + this.institution.id)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    async getDepartments(id) {
      await this.apiService
        .get(`department/list/unidade/${id}`, true, false)
        .then((response) => {
          this.departments = response.content
        })
    },

    getSubDepartments(departmentId, resetSubDepartment = true) {
      if (resetSubDepartment) {
        this.data.subDepartmentId = null
      }

      const department = this.departments.find((x) => x.id == departmentId)
      this.subDepartments =
        department && department.subDepartments ? department.subDepartments : []
    },

    formatDateTime(date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm') : ''
    },

    confirm() {
      if (this.$refs.form.validate()) {
        const fieldMap = {
          [FIELD_KEYS.UNIDADE]: 'unidadeId',
          [FIELD_KEYS.SETOR]: 'departmentId',
          [FIELD_KEYS.SUB_SETOR]: 'subDepartmentId',
          [FIELD_KEYS.LOCALIZACAO]: 'location',
          [FIELD_KEYS.IDENTIFICACAO]: 'equipmentId',
          [FIELD_KEYS.NOME_OS]: 'name',
          [FIELD_KEYS.SOLICITANTE]: 'requester',
          [FIELD_KEYS.TIPO_OS]: 'serviceOrderType',
          [FIELD_KEYS.RESPONSAVEL]: 'responsibleName',
          [FIELD_KEYS.DATA_HORA_SOLICITACAO]: 'dateTimeRequest',
          [FIELD_KEYS.SOLICITACAO_RECLAMACAO]: 'request',
          [FIELD_KEYS.OFICINA]: 'workshopId',
        }
        
        const dataToEmit = {
          unidadeId: null,
          departmentId: null,
          subDepartmentId: null,
          location: '',
          equipmentId: null,
          name: '',
          requester: '',
          serviceOrderType: null,
          responsibleName: '',
          dateTimeRequest: '',
          request: '',
          workshopId: null,
        }
        
        if (
          this.selectedFields.includes(FIELD_KEYS.DATA_HORA_SOLICITACAO) &&
          !this.data.dateTimeRequest
        ) {
          this.requestDateTimeError = true
          return
        }

        this.selectedFields.forEach(field => {
          const dataKey = fieldMap[field]
          if (dataKey && this.data[dataKey] !== undefined) {
            dataToEmit[dataKey] = this.data[dataKey]
          }
        })

        if (dataToEmit.dateTimeRequest) {
          dataToEmit.dateTimeRequest = moment(dataToEmit.dateTimeRequest).format('YYYY-MM-DDTHH:mm:ss')
        }

        this.$emit('confirm', dataToEmit)
      }
    },
  },

  watch: {
    'data.dateTimeRequest'() {
      this.requestDateTimeError = false
    },

    async equipments() {
      if (this.category == 0 && this.data.equipmentId) {
        await this.syncDepartmentAndSubDepartmentByEquipment()
      }
    },
  },
}
</script>

<style>
.vc-popover-content-wrapper {
  z-index: 999 !important;
}
.date-input {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 1px solid #707070 !important;
  padding-left: 10px !important;
}
.date-input-error {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 2px solid #ff5252 !important;
  padding-left: 10px !important;
}
.date-span-error {
  color: #ff5252;
  font-size: 12px;
  padding-left: 4px;
}
</style>
